import { useAuth } from '../lib/auth';
import { useFormatters, useI18n } from '../i18n';
import { parseInstant } from '../lib/format';

/**
 * Remaining runs, in the header, always visible while signed in.
 *
 * The app is public, so the quota is a real constraint rather than a detail:
 * a user who has one run left should find that out before spending twenty
 * minutes building a query, not after.
 */
export function QuotaBadge() {
  const { status, quota, quotaLoading, quotaError } = useAuth();
  const i18n = useI18n();
  const fmt = useFormatters();

  if (status !== 'signed-in') return null;

  const label = i18n.t('header.quotaLabel');

  if (quotaLoading && !quota) {
    return (
      <span className="quota">
        <span className="quota__label">{label}</span>
        <span className="quota__value">{i18n.t('header.quotaLoading')}</span>
      </span>
    );
  }

  if (!quota) {
    return (
      <span className="quota" title={quotaError ?? undefined}>
        <span className="quota__label">{label}</span>
        <span className="quota__value">{i18n.t('header.quotaFailed')}</span>
      </span>
    );
  }

  const resetsAt = parseInstant(quota.resets_at);
  const resetsText = resetsAt ? fmt.dateTime(resetsAt) : i18n.t('common.dash');

  return (
    <span
      className={!quota.unlimited && quota.remaining <= 0 ? 'quota quota--empty' : 'quota'}
      title={i18n.t('header.quotaTooltip', {
        remaining: quota.remaining,
        limit: quota.limit,
        time: resetsText,
      })}
    >
      <span className="quota__label">{label}</span>
      <span className="quota__value">
        {quota.unlimited
          ? i18n.t('common.unlimited')
          : i18n.t('header.quotaValue', { remaining: quota.remaining, limit: quota.limit })}
      </span>
    </span>
  );
}
